import React from "react";
import GenericDrawer from "./GenericDrawer";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors";
import { DrawerType, VerticalTransition } from "../../constants";
import QuickLinksMenu from "../MenuV2/QuickLinksMenu";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader";
import { useNoScroll } from "../../hooks";

const QuickLinksInnerDrawer = function () {
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );

  useNoScroll("quickLinksInnerDrawer", quickLinksInnerMenuVisible);

  return (
    <GenericDrawer
      isVisible={quickLinksInnerMenuVisible}
      menu={DrawerType.QuickLinksInnerMenu}
      header={<MobileDrawerHeader menu={DrawerType.QuickLinksInnerMenu} />}
      verticalTransition={VerticalTransition.Left}
    >
      <QuickLinksMenu />
    </GenericDrawer>
  );
};

export default React.memo(QuickLinksInnerDrawer);
